// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.deiTK__carousel {
  position: relative;
  padding: 2em 0 1em;
  background: var(--color-grey-4);
  transition: background var(--default-transition-duration) var(--default-transition-timing);
  box-shadow: inset 0 0 16px 6px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
}

@media (prefers-color-scheme: dark) {

.rescueally:not(.rescueally-light) .deiTK__carousel {
    background: black;
}
  }

.rescueally.rescueally-dark .deiTK__carousel {
    background: black;
}

.deiTK__carousel .yUlgi__header {
    color: white;
    padding: 0 var(--content-inset);
    font-family: var(--heading-font);
    font-weight: normal;
  }

@media screen and (min-width: 430px) {

.deiTK__carousel .yUlgi__header {
      padding: 0 var(--content-inset);
  }
    }

@media screen and (min-width: 1024px) {

.deiTK__carousel .yUlgi__header {
      margin: 0 auto;
      margin-bottom: 2em;
  }
    }

.DsMU9__items {
  flex: 1;
  display: flex;
  align-items: center;
  overflow-x: auto;
  overflow-y: visible;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.C7_vV__carouselItem {
  position: relative;
  display: flex;
  justify-content: center;
  width: calc(100% - 4em);
  flex-shrink: 0;
  margin: 0 2em;
  padding: 1em 0;
  max-height: 100%;
}

@media (min-width: 700px) {

.C7_vV__carouselItem::before,.C7_vV__carouselItem::after {
      display: block;
      content: '';
      transition: flex var(--default-transition-duration) var(--default-transition-timing);
  }
    }

.C7_vV__carouselItem::before {
    flex: 1;
  }

.C7_vV__carouselItem::after {
    flex: 1;
  }

@media (min-width: 700px) {

.C7_vV__carouselItem::after {
      flex: 3;
  }
    }

@media screen and (min-width: 640px) {

.C7_vV__carouselItem {
    justify-content: flex-start;
}
  }

@media screen and (min-width: 1200px) {

.C7_vV__carouselItem {
    margin: 0;
    width: calc(50%);
}
  }

@media screen and (min-width: 1200px) {
  .buihl__scrollEven .C7_vV__carouselItem::before {
    flex: 3;
  }
}

@media screen and (min-width: 1200px) {
  .hWPjc__scrollOdd .C7_vV__carouselItem::before {
    flex: 0.3;
  }
}

@media screen and (min-width: 1200px) {

.nnE1c__start:last-child {
    margin-right: 50%;
}
  }
.DAIsa__end {
}

.FNcD0__phoneFrame {
  position: relative;
  z-index: 10;
}

.JtOB7__annotations {
}

.J30H5__annotation {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
  --card-header-font-weight: bold;
}

@media (max-width: 360px) {

.J30H5__annotation {
    font-size: 0.9em;
}
  }

@media screen and (min-width: 640px) {

.J30H5__annotation {
    z-index: -1;
}
  }

@media screen and (min-width: 640px) {

.C7_vV__carouselItem.nnE1c__start .JtOB7__annotations .J30H5__annotation {
        left: -1em;
    }
      }

.C7_vV__carouselItem.nnE1c__start .JtOB7__annotations .wild-card-header {
      flex-direction: row-reverse;
    }

.C7_vV__carouselItem.nnE1c__start .JtOB7__annotations .wild-card-body {
      display: flex;
      justify-content: flex-end;
    }

.C7_vV__carouselItem.DAIsa__end {
  position: relative;
  display: flex;
  flex-direction: row-reverse;
}

.C7_vV__carouselItem.DAIsa__end .FNcD0__phoneFrame {
    display: flex;
  }

@media screen and (min-width: 640px) {

.C7_vV__carouselItem.DAIsa__end .FNcD0__phoneFrame {
      justify-content: flex-end;
  }
    }

@media screen and (min-width: 640px) {

.C7_vV__carouselItem.DAIsa__end .J30H5__annotation {
      right: -1em;
  }
    }

.HroME__phone {
  max-width: 100%;
  height: 100%;
}

.hcHOe__screenshot {
  width: 100%;
  max-width: var(--phone-width);
}

.FsphX__controls {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5em;
  margin-top: 0.5em;
}

.FsphX__controls .q1LbA__controlsInner {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: width var(--default-transition-duration) cubic-bezier(0, 1.15, 0.88, 0.98);
  }

.FsphX__controls .q1LbA__controlsInner.RklvZ__one {
      width: 2.75em;
    }

.FsphX__controls .q1LbA__controlsInner._4fo3__two {
      width: 6em;
    }

.FsphX__controls .q1LbA__controlsInner.wbZ96__left {
      justify-content: flex-start;
    }

.FsphX__controls .q1LbA__controlsInner.AXZ8Z__right {
      justify-content: flex-end;
    }

.FsphX__controls button {
    color: black !important;
    background: white !important;
    border: none !important;
    border-radius: 50%;
    padding: 0.7em 0.56em;
  }

@media (prefers-color-scheme: dark) {

.rescueally:not(.rescueally-light) .FsphX__controls button {
      color: white !important;
      background: var(--color-grey-5) !important;
  }
    }

.rescueally.rescueally-dark .FsphX__controls button {
      color: white !important;
      background: var(--color-grey-5) !important;
  }

.JCgyI__pips {
  position: absolute;
  display: flex;
  align-items: center;
  gap: 0.4em;
  padding: 0 0.6em;
  top: 50%;
}

.wqru1__pipsLeft {
  left: -3em;
}

.mkz20__pipsRight {
  right: -3em;
}

.OdeYU__pip {
  width: 6px;
  height: 6px;
  background: white;
  border-radius: 50%;
}
`, "",{"version":3,"sources":["webpack://./src/components/ScreenshotCarousel.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,0FAA0F;EAC1F,iDAAiD;EACjD,aAAa;EACb,sBAAsB;AAqBxB;;AAnBE;;AATF;IAUI,iBAAiB;AAkBrB;EAjBE;;AAXF;IAUI,iBAAiB;AAkBrB;;AAfE;IACE,YAAY;IACZ,+BAA+B;IAC/B,gCAAgC;IAChC,mBAAmB;EAUrB;;AARE;;AANF;MAOI,+BAA+B;EAOnC;IANE;;AAEA;;AAVF;MAWI,cAAc;MACd,kBAAkB;EAEtB;IADE;;AAIJ;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,cAAc;EACd,gBAAgB;AA+BlB;;AA3BI;;AAFF;MAGI,cAAc;MACd,WAAW;MACX,oFAAoF;EAExF;IADE;;AAGF;IACE,OAAO;EACT;;AAEA;IACE,OAAO;EAKT;;AAHE;;AAHF;MAII,OAAO;EAEX;IADE;;AAGF;;AA/BF;IAgCI,2BAA2B;AAO/B;EANE;;AAEA;;AAnCF;IAoCI,SAAS;IACT,gBAAgB;AAEpB;EADE;;AAGF;EACE;IACE,OAAO;EACT;AACF;;AAEA;EACE;IACE,SAAS;EACX;AACF;;AAGE;;AADF;IAEI,iBAAiB;AAErB;EADE;AAEF;AACA;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;AACA;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,UAAU;EACV,+BAA+B;AASjC;;AAPE;;AARF;IASI,gBAAgB;AAMpB;EALE;;AAEA;;AAZF;IAaI,WAAW;AAEf;EADE;;AAMI;;AADF;QAEI,UAAU;IAEd;MADE;;AAGF;MACE,2BAA2B;IAC7B;;AAEA;MACE,aAAa;MACb,yBAAyB;IAC3B;;AAIJ;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;AAc7B;;AAZE;IACE,aAAa;EAIf;;AAHE;;AAFF;MAGI,yBAAyB;EAE7B;IADE;;AAIA;;AADF;MAEI,WAAW;EAEf;IADE;;AAIJ;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AAsCnB;;AApCE;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sFAAsF;EAiBxF;;AAfE;MACE,aAAa;IACf;;AAEA;MACE,UAAU;IACZ;;AAEA;MACE,2BAA2B;IAC7B;;AAEA;MACE,yBAAyB;IAC3B;;AAGF;IACE,uBAAuB;IACvB,4BAA4B;IAC5B,uBAAuB;IACvB,kBAAkB;IAClB,qBAAqB;EAMvB;;AAJE;;AAPF;MAQI,uBAAuB;MACvB,0CAA0C;EAE9C;IADE;;AAVF;MAQI,uBAAuB;MACvB,0CAA0C;EAE9C;;AAGF;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB","sourcesContent":[".carousel {\n  position: relative;\n  padding: 2em 0 1em;\n  background: var(--color-grey-4);\n  transition: background var(--default-transition-duration) var(--default-transition-timing);\n  box-shadow: inset 0 0 16px 6px rgba(0, 0, 0, 0.3);\n  display: flex;\n  flex-direction: column;\n\n  @media (prefers-color-scheme: dark) {\n    background: black;\n  }\n\n  & .header {\n    color: white;\n    padding: 0 var(--content-inset);\n    font-family: var(--heading-font);\n    font-weight: normal;\n\n    @media (--screen-sm) {\n      padding: 0 var(--content-inset);\n    }\n\n    @media (--screen-lg) {\n      margin: 0 auto;\n      margin-bottom: 2em;\n    }\n  }\n}\n\n.items {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  overflow-x: auto;\n  overflow-y: visible;\n  -ms-overflow-style: none;\n  scrollbar-width: none;\n}\n\n.carouselItem {\n  position: relative;\n  display: flex;\n  justify-content: center;\n  width: calc(100% - 4em);\n  flex-shrink: 0;\n  margin: 0 2em;\n  padding: 1em 0;\n  max-height: 100%;\n\n  &::before,\n  &::after {\n    @media (min-width: 700px) {\n      display: block;\n      content: '';\n      transition: flex var(--default-transition-duration) var(--default-transition-timing);\n    }\n  }\n\n  &::before {\n    flex: 1;\n  }\n\n  &::after {\n    flex: 1;\n\n    @media (min-width: 700px) {\n      flex: 3;\n    }\n  }\n\n  @media (--screen-md) {\n    justify-content: flex-start;\n  }\n\n  @media (--screen-xl) {\n    margin: 0;\n    width: calc(50%);\n  }\n}\n\n@media (--screen-xl) {\n  .scrollEven .carouselItem::before {\n    flex: 3;\n  }\n}\n\n@media (--screen-xl) {\n  .scrollOdd .carouselItem::before {\n    flex: 0.3;\n  }\n}\n\n.start:last-child {\n  @media (--screen-xl) {\n    margin-right: 50%;\n  }\n}\n.end {\n}\n\n.phoneFrame {\n  position: relative;\n  z-index: 10;\n}\n\n.annotations {\n}\n\n.annotation {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 1;\n  --card-header-font-weight: bold;\n\n  @media (max-width: 360px) {\n    font-size: 0.9em;\n  }\n\n  @media (--screen-md) {\n    z-index: -1;\n  }\n}\n\n.carouselItem.start {\n  & .annotations {\n    & .annotation {\n      @media (--screen-md) {\n        left: -1em;\n      }\n    }\n\n    & :global(.wild-card-header) {\n      flex-direction: row-reverse;\n    }\n\n    & :global(.wild-card-body) {\n      display: flex;\n      justify-content: flex-end;\n    }\n  }\n}\n\n.carouselItem.end {\n  position: relative;\n  display: flex;\n  flex-direction: row-reverse;\n\n  & .phoneFrame {\n    display: flex;\n    @media (--screen-md) {\n      justify-content: flex-end;\n    }\n  }\n\n  & .annotation {\n    @media (--screen-md) {\n      right: -1em;\n    }\n  }\n}\n\n.phone {\n  max-width: 100%;\n  height: 100%;\n}\n\n.screenshot {\n  width: 100%;\n  max-width: var(--phone-width);\n}\n\n.controls {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5em;\n  margin-top: 0.5em;\n\n  & .controlsInner {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    transition: width var(--default-transition-duration) cubic-bezier(0, 1.15, 0.88, 0.98);\n\n    &.one {\n      width: 2.75em;\n    }\n\n    &.two {\n      width: 6em;\n    }\n\n    &.left {\n      justify-content: flex-start;\n    }\n\n    &.right {\n      justify-content: flex-end;\n    }\n  }\n\n  & button {\n    color: black !important;\n    background: white !important;\n    border: none !important;\n    border-radius: 50%;\n    padding: 0.7em 0.56em;\n\n    @media (prefers-color-scheme: dark) {\n      color: white !important;\n      background: var(--color-grey-5) !important;\n    }\n  }\n}\n\n.pips {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  gap: 0.4em;\n  padding: 0 0.6em;\n  top: 50%;\n}\n\n.pipsLeft {\n  left: -3em;\n}\n\n.pipsRight {\n  right: -3em;\n}\n\n.pip {\n  width: 6px;\n  height: 6px;\n  background: white;\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
export var carousel = `deiTK__carousel`;
export var header = `yUlgi__header`;
export var items = `DsMU9__items`;
export var carouselItem = `C7_vV__carouselItem`;
export var scrollEven = `buihl__scrollEven`;
export var scrollOdd = `hWPjc__scrollOdd`;
export var start = `nnE1c__start`;
export var end = `DAIsa__end`;
export var phoneFrame = `FNcD0__phoneFrame`;
export var annotations = `JtOB7__annotations`;
export var annotation = `J30H5__annotation`;
export var phone = `HroME__phone`;
export var screenshot = `hcHOe__screenshot`;
export var controls = `FsphX__controls`;
export var controlsInner = `q1LbA__controlsInner`;
export var one = `RklvZ__one`;
export var two = `_4fo3__two`;
export var left = `wbZ96__left`;
export var right = `AXZ8Z__right`;
export var pips = `JCgyI__pips`;
export var pipsLeft = `wqru1__pipsLeft`;
export var pipsRight = `mkz20__pipsRight`;
export var pip = `OdeYU__pip`;
export default ___CSS_LOADER_EXPORT___;
